<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>
		<v-card-text class="text-left mx-auto">

			<v-list lines="three">
				<v-list-item
					v-for="file in files"
					:key="file.name"
					:subtitle="file.description"
					:title="file.name"
					@click="onOpen(file)"
				>
					<template v-slot:prepend>
						<v-avatar>
							<v-icon v-if="file.extension=='pdf'" icon="mdi-file-pdf-box" color="red darken-4" size="x-large"></v-icon>
							<v-icon v-else icon="mdi-file" color="black" size="x-large"></v-icon>
						</v-avatar>
					</template>

					<template v-slot:append>
						<v-btn
							icon="mdi-download"
							variant="text"
							@click.stop="onDowdload(file)"
						></v-btn>
					</template>
				</v-list-item>
			</v-list>
			<!-- <v-btn class="my-6 me-2 text-none font-weight-bold" block @click="onDiiaSign">Підписати за використанням “Дія ID”</v-btn> -->

			
		</v-card-text>
		<v-card-text class="mx-auto" v-if="deeplink">

			<div class="my-6 text-subtitle-2 font-weight-bold">Відскануйте QR-код телефоном з установленою Дією</div>


			<QRCodeVue3 v-if="qrcode.visible" 
				:value="qrcode.value"
				:dotsOptions="qrcode.dotsOptions"
				:cornersSquareOptions="{ type: 'square', color: '#000000' }"
				:cornersDotOptions="{ type: undefined, color: '#000000' }"
			></QRCodeVue3>

			<!-- <QRCodeVue3
				:width="200"
				:height="200"
				:value="deeplink"
				:qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
				:imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
				:dotsOptions="{
					type: 'dots',
					color: '#26249a',
					gradient: {
					type: 'linear',
					rotation: 0,
					colorStops: [
						{ offset: 0, color: '#26249a' },
						{ offset: 1, color: '#26249a' },
					],
					},
				}"
				:backgroundOptions="{ color: '#ffffff' }"
				:cornersSquareOptions="{ type: 'dot', color: '#000000' }"
				:cornersDotOptions="{ type: undefined, color: '#000000' }"
				fileExt="png"
				:download="true"
				myclass="my-qur"
				imgclass="img-qr"
				downloadButton="my-button"
				:downloadOptions="{ name: 'vqr', extension: 'png' }"
				/> -->

				<div class="my-6 text-subtitle-2 font-weight-bold">або</div>

				<v-btn class="my-6 me-2 text-none font-weight-bold" block :href="qrcode.value" target="_blank">Перейти в Дію</v-btn>
		</v-card-text>
		<v-card-text class="mx-auto" v-else>
			<v-btn class="my-6 me-2 text-none font-weight-bold" block @click="onDiiaSign">Підписати за використанням “Дія ID”</v-btn>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/main'
import QRCodeVue3 from "qrcode-vue3" //https://www.npmjs.com/package/qrcode-vue3

export default {
	name: 'ComponentSignFile',
	mixins: [mixin],
	components: { QRCodeVue3 },
	data: () => ({
		deeplink: null,
		qrcode: {
			visible: false,
			value: null,
			dotsOptions: {
				//type: 'dots',
				color: '#00AF66',
				gradient: {
					type: 'linear',
					rotation: 0,
					colorStops: [
						{ offset: 0, color: '#00AF66' },
						{ offset: 1, color: '#001E60' },
					],
				},
			}
		},
	}),
	computed: {
		//...mapGetters([ 'ClaimNumber' ]),

		files() {
			//console.log(this.$options.name, 'files', 'item', this.item)

			return this.item?.files ? this.item.files : []
		},
	},

	methods: {
		showQRcode(value) {
			this.qrcode.visible = false
			this.qrcode.value = value
			this.qrcode.visible = true
		},

		onOpen(item) {
			//console.log(this.$options.name, 'onOpen', 'item', item)
	
			var that = this
			axios.get(item.path, { responseType: 'blob' }).then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' })
				const blobUrl = URL.createObjectURL(blob);
    			window.open(blobUrl, '_blank');

			}).catch(console.error)

		},

		onDowdload(item) {
			//console.log(this.$options.name, 'onDowdload', 'path', item.path)
			
			var that = this
			axios.get(item.path, { responseType: 'blob' }).then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' })
				const link = document.createElement('a')
				link.href = URL.createObjectURL(blob)
				link.download = item.filename
				link.click()
				URL.revokeObjectURL(link.href)
			}).catch(console.error)
		},
		
		onDiiaSign() {
			//console.log(this.$options.name, 'onDiiaSign', 'item', this.item)

			var that = this
			this.loading = true
			return axios.post(`/diia/offer/request`, this.item).then(response => {
				//console.log(that.$options.name, 'onDiiaSign','response.data', response.data)
				
				that.deeplink = response.data?.deeplink ? response.data.deeplink : null;
				this.showQRcode(that.deeplink)
			}, error => {
				//console.log('error', error)
				this.showMessage(error)
			}).finally(() => { this.loading = false });
		},
	},
}
</script>
